import React from 'react';

const MonitorIcon = () => (
  <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='10.5' y='24' width='100' height='64' rx='6' stroke='black' strokeWidth='4.4' />
    <path d='M78.5 100H42.5' stroke='black' strokeWidth='4.4' strokeLinecap='round' strokeLinejoin='round' />
    <circle cx='61' cy='67.5' r='3.5' fill='var(--theme-primary, #810ea9)' />
    <path
      d='M71.5 58C68.7784 55.4244 65.0775 54 61 54C56.9225 54 53.2216 55.4244 50.5 58'
      stroke='var(--theme-primary, #810ea9)'
      strokeWidth='4.4'
      strokeLinecap='round'
    />
    <path
      d='M40.5 50C45.8137 44.8489 53.0393 42 61 42C63.9547 42 67.808 42.7431 70.5 43.5'
      stroke='var(--theme-primary, #810ea9)'
      strokeWidth='4.4'
      strokeLinecap='round'
    />
    <path d='M76.393 50L81.5001 55L89.393 47' stroke='black' strokeWidth='4.4' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default MonitorIcon;
